angular.module('app').factory('notificationService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        var notifications = restAngular.all("/notification/");

        return {
            getUserNotifications: function () {
                return notifications.
                    one("getUserNotifications").
                    get()
            },
            readNotification: function (userNotificationId) {
                return notifications.
                    one("readUserNotification").
                    get({user_not_id: userNotificationId})
            }
        }
    }
]);